<template>
  <slot v-if="state.postSuccess === false">
    <h3>Étape {{ step }} sur {{ maxStep }}</h3>
    <ProgressBar :step="step" :maxStep="maxStep"></ProgressBar>

    <div class="form-container">
      <slot v-if="step === 1">
        <FirstStep :v="v1"></FirstStep>
      </slot>

      <slot v-if="step === 2">
        <h3>Informations concernant votre formation</h3>
        <SecondStep :v="v2"></SecondStep>
      </slot>

      <slot v-if="step === maxStep">
        <h3>Document à nous transmettre</h3>
        <LastStep></LastStep>
      </slot>

      <div class="buttons-navigate">
        <button style="float: left" v-if="step > 1" @click="previousStep()">Précédent</button>
        <button style="float: right" v-if="step < maxStep" @click="nextStep()">Suivant</button>
      </div>
    </div>

    <Toast></Toast>
  </slot>

  <div class="success" v-else>
    <p>{{ state.respMsg }}</p>
  </div>
</template>

<script>
import { ref } from "vue";
import FirstStep from "./Forms/FirstStep.vue";
import SecondStep from "./Forms/SecondStep.vue";
import LastStep from "./Forms/LastStep.vue";
import ProgressBar from "./ProgressBar.vue";
import { getStateFormUser, getStateFormFormation } from "../validation";
import { state } from "../store";
import Toast from "./Toast.vue";

export default {
  name: "Widget",
  components: { FirstStep, SecondStep, LastStep, ProgressBar, Toast },

  setup() {
    const step = ref(1);
    const maxStep = 3;
    const compoUser = getStateFormUser();
    const compoFormations = getStateFormFormation();

    const previousStep = () => {
      if (step.value === 1) {
        return step.value;
      }
      else {
        step.value--;
      }
    };

    const nextStep = async () => {

      if (step.value === 1) {
        await compoUser.validate();

        if (compoUser.v1.value.$invalid) {
          return false;
        }
      }

      if (step.value === 2) {
        await compoFormations.validate();

        if (compoFormations.v2.value.$invalid) {
          return false;
        }
      }

      step.value++;
    };

    return { step, maxStep, state, previousStep, nextStep, ...compoUser, ...compoFormations };
  }
};
</script>

<style scoped lang='scss'>
@import "../scss/variables";
.success {
  background-color: #19c8a6;
  width: 100%;
  padding: 0.5rem;
  text-align: center;
  p {
    color: white;
    margin: 0;
  }
}
.form-container {
  position: relative;
}
.buttons-navigate {
  margin-top: 2em;
  @include buttonStyle($base-color, 2px solid $base-color, white);
}

.completed {
  height: 3rem;
  width: 100%;
}
</style>
